<template>
  <div class="leftres">
    <div>
      <div :class=" showorhide ? 'inputtop' : 'inputtops' ">
        <div v-for="(item , index) of formdata" :key="index" style="display: inline-block;">
          <Commondropdownlist ref="producselect" :key="index" :options="item.options" :lablewith="item.lablewith" :inputdata="item.inputdata" :title="item.title" :fontSize="item.fontSize" :color="item.color" :placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype" :width="item.width"></Commondropdownlist>
        </div>
        <div class="Btngroups">
          <CommonBtngroup :qhide="false" @hide="hide" @select="select" @reset="reset"></CommonBtngroup>
        </div>
        <div style="height:10px;">
        </div>
      </div>

      <div class="TableBox" style="box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1); margin-top: 10px; background-color: #FFFFFF;">
        <Productfiletable :tableData="tableData" :total="total" @proExport="proExport" @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange"></Productfiletable>
      </div>
      <Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibles" @cancel="cancel" @dialogOK="dialogOK" :src="'../assets/icon/icon-errors.png'">
        <span style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要重置选中账号的密码吗？</span>
      </Dialog>
    </div>
  </div>
</template>

<script>
import Commondropdownlist from '../../../components/common-dropdownlist.vue'
import CommonBtngroup from '../../../components/commongroup.vue'
import Dialog from '../../../components/dialog.vue'
import Productfiletable from './components/productfiletable.vue'
import utils from '../../../common/utils'
import { InventoryList, InventoryClassList, InventorExport } from '@/api/home'
export default {
  components: {
    Commondropdownlist,
    Productfiletable,
    Dialog,
    CommonBtngroup
  },
  data() {
    return {
      total: 1,
      pageindex: 1,
      pageSize: 20,
      tableData: [],
      dialogVisibles: false,
      showorhide: true,
      invCode: "",
      invAddCode: "",
      invName: "",
      invClass: "",
      formdata: [
        {
          inputdata: '',
          title: '产品编号',
          fontSize: '14px',
          color: '#333333',
          placeholder: '请输入',
          types: 'text',
          inputtype: 'input',
          width: '210px',
          lablewith: '70px'
        },
        {
          inputdata: '',
          title: '产品名称',
          fontSize: '14px',
          color: '#333333',
          placeholder: '请输入',
          types: 'text',
          inputtype: 'input',
          width: '210px'
        }, {
          inputdata: '',
          title: '产品线编号',
          fontSize: '14px',
          color: '#333333',
          placeholder: '请输入',
          types: '',
          inputtype: 'select',
          width: '210px',
          lablewith: '110px',
          options: []
        },

      ]
    }
  },
  mounted() {
    this.inventoryList()
    this.InventoryClassList()
  },
  methods: {
    // 列表
    async inventoryList() {
      const loading = this.$loading({
        lock: true,
        text: '正在加载列表...',
        spinner: 'el-icon-loading',
        background: 'rgba(255,255,255,0.3)'
      });
      let {
        data,
        code,
        message
      } = await InventoryList({
        invAddCode: this.invAddCode,
        invName: this.invName,
        invClass: this.invClass,
        pageSize: this.pageSize,
        pageIndex: this.pageindex
      })
      if (code == 0) {
        this.total = data.Count
        if (data.data) {
          this.tableData = data.data
        }
      } else {
        this.$message({
          type: "error",
          message: message
        })
      }
      loading.close();
    },
    // 产品线
    async InventoryClassList() {
      let {
        code,
        data
      } = await InventoryClassList({
      })
      if (code == 0) {
        this.formdata[2].options = []
        data.data.map((item, index) => {
          let obj = {
            key: item.InvClass,
            value: item.InvClassName
          }
          this.formdata[2].options.push(obj)
        })
      }
    },
    // 导出
    async inventorExport() {
      const loading = this.$loading({
        lock: true,
        text: '正在导出...',
        spinner: 'el-icon-loading',
        background: 'rgba(255,255,255,0.3)'
      });
      let resexprot = await InventorExport({
        invAddCode: this.invAddCode,
        invName: this.invName,
        invClass: this.invClass,
        pageSize: this.pageSize,
        pageIndex: this.pageindex
      })
      if (resexprot) {
        let date = new Date()
        let str = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}-${date.getTime()}`
        utils.downloadFile(resexprot, `产品档案导出${str}`, "xlsx")
        loading.close();
      } else {
        // 返回json
        this.$message.warning('导出失败');
        loading.close();
      }
      loading.close()
    },

    proExport() {
      this.inventorExport()
    },
    reset() {
      this.$refs.producselect.map((item, index) => {
        item.modelvalue = ''
      })
    },
    cancel() {
      this.dialogVisibles = false
    },
    dialogOK() {
      this.dialogVisibles = false
    },
    hide() {
      this.showorhide = false
    },
    showclick() {
      this.showorhide = true
    },
    select() {
      try {
        this.pageindex = 1
        this.invAddCode = this.$refs.producselect[0].modelvalue
        this.invName = this.$refs.producselect[1].modelvalue
        this.invClass = this.$refs.producselect[2].modelvalue
        this.inventoryList()
      } catch (error) {
        this.inventoryList()
      }
    },
    handleCurrentChange(pageindex) {
      this.pageindex = pageindex
      this.inventoryList()
      //console.log(pageindex, 'pageindex')

    },
    handleSizeChange(paegSzie) {
      this.pageSize = paegSzie
      this.inventoryList()
    },
  }
}
</script>

<style lang="less" scoped>
.inputtop {
  width: 980px;
  height:10px;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  padding-top: 15px;
  padding-bottom: 70px;
  transition: all 0.3s;
  overflow: hidden;
  position: relative;
}
.inputtops {
  width: 980px;
  height: 20px;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  padding-top: 9px;
  padding-bottom: 64px;
  overflow: hidden;
  position: relative;
  transition: all 0.3s;
}
.Btngroup {
  display: inline-block;
  float: right;
  margin-right: 20px;
  width: 300px;
  height: 50px;
  background-color: #ffffff;
  position: relative;
  bottom: 45px;
}
.Btngroups {
  display: inline-block;
  float: right;
  margin-top: 5px;
  margin-right: 0px;
}
</style>